import type { TranslationDict } from "./en";
import { guestCheckoutBn } from "./guest-checkout";

export const bn: TranslationDict = {
  common: {
    addToCart: "কার্টে যোগ করুন",
    buyNow: "এখনই কিনুন",
    viewDetails: "বিস্তারিত দেখুন",
    quickView: "দ্রুত দেখুন",
    loading: "লোড হচ্ছে...",
    error: "একটি ত্রুটি ঘটেছে",
    search: "পণ্য খুঁজুন...",
    searchPlaceholder: "আপনি কি খুঁজছেন?",
    noResults: "কোন ফলাফল পাওয়া যায়নি",
    tryAgain: "আবার চেষ্টা করুন",
    yes: "হ্যাঁ",
    no: "না",
    cancel: "বাতিল",
    delivery: "ডেলিভারি",
    paymentFee: "পেমেন্ট ফি",
    free: "ফ্রি",
  },
  product: {
    inStock: "স্টকে আছে",
    outOfStock: "স্টক শেষ",
    lowStock: "মাত্র {count} টি বাকি",
    specifications: "বৈশিষ্ট্য",
    description: "বর্ণনা",
    reviews: "পর্যালোচনা",
    relatedProducts: "সম্পর্কিত পণ্য",
    relatedProductsDescription: "আপনার জন্য নির্বাচিত পণ্য",
    newArrival: "নতুন",
    featured: "বৈশিষ্ট্যযুক্ত",
    sale: "বিক্রয়",
    brand: "ব্র্যান্ড",
    sku: "এসকেইউ",
    category: "বিভাগ",
    tags: "ট্যাগ",
    quantity: "পরিমাণ",
    save: "সংরক্ষণ",
    available: "উপলব্ধ",
    outOfStockVariant: "স্টক শেষ",
    selectVariant: "একটি ভ্যারিয়েন্ট নির্বাচন করুন",
    selectVariantMessage: "কার্টে যোগ করার আগে সমস্ত ভ্যারিয়েন্ট অপশন নির্বাচন করুন",
    selectVariantBuyMessage: "কেনার আগে সমস্ত ভ্যারিয়েন্ট অপশন নির্বাচন করুন",
    addedToCart: "কার্টে যোগ হয়েছে!",
    productAddedToCart: "{name} আপনার কার্টে যোগ হয়েছে",
    redirectingToCart: "কার্টে পুনঃনির্দেশিত হচ্ছে",
    adding: "যোগ করা হচ্ছে...",
    chooseVariant: "ভ্যারিয়েন্ট বেছে নিন",
    addToCartFailed: "কার্টে যোগ করা যায়নি",
    addToCartFailedMessage: "{name} যোগ করা যায়নি। আবার চেষ্টা করুন।",
  },
  // Product listings (brand pages, /products, search results)
  listing: {
    filters: "ফিল্টার",
    clearAll: "সব মুছুন",
    priceRange: "দামের সীমা",
    sortRelevance: "সবচেয়ে প্রাসঙ্গিক",
    sortPriceAsc: "দাম: কম থেকে বেশি",
    sortPriceDesc: "দাম: বেশি থেকে কম",
    sortNameAsc: "নাম: A-Z",
    sortNameDesc: "নাম: Z-A",
    sortNewest: "নতুন আগে",
    sortPopular: "সবচেয়ে জনপ্রিয়",
    noProducts: "কোনো পণ্য পাওয়া যায়নি",
    noSearchResults: '"{query}"-এর জন্য কোনো পণ্য পাওয়া যায়নি। অন্য শব্দ দিয়ে খুঁজুন।',
    noFilterResults: "বাছাই করা ফিল্টারে কোনো পণ্য মেলেনি। ফিল্টার বদলান বা মুছে দিন।",
    noBrandProducts: "এই ব্র্যান্ডের কোনো পণ্য পাওয়া যায়নি।",
    clearSearch: "সার্চ মুছুন",
    clearAllFilters: "সব ফিল্টার মুছুন",
    searchResultsFor: '"{query}"-এর সার্চ ফলাফল',
    searchResultsTitle: "“{query}”-এর সার্চ ফলাফল",
    products: "পণ্য",
    filtering: "পণ্য খোঁজা হচ্ছে…",
    filterCategories: "ক্যাটাগরি",
    filterBrands: "ব্র্যান্ড",
  },
  pagination: {
    showing: "{total}টি ফলাফলের মধ্যে {from} থেকে {to}",
    previous: "আগের",
    next: "পরের",
    pageOf: "/ {total}",
  },
  cart: {
    title: "শপিং কার্ট",
    empty: "আপনার কার্ট খালি",
    emptyDescription:
      "মনে হচ্ছে আপনি এখনো কার্টে কিছু যোগ করেননি। কেনাকাটা শুরু করে কার্ট ভরে ফেলুন!",
    startShopping: "কেনাকাটা শুরু করুন",
    subtotal: "উপমোট",
    subtotalItems: "উপমোট ({count}টি পণ্য)",
    total: "মোট",
    checkout: "চেকআউট এ যান",
    continueShopping: "কেনাকাটা চালিয়ে যান",
    remove: "সরান",
    quantity: "পরিমাণ",
    loadingCart: "কার্ট লোড হচ্ছে...",
    clearCart: "কার্ট খালি করুন",
    clearConfirm: "সব পণ্য মুছবেন?",
    syncing: "সর্বশেষ দাম দিয়ে কার্ট আপডেট হচ্ছে...",
    itemsUpdated: "কিছু পণ্য আপডেট হয়েছে:",
    itemRemoved: "{name} আপনার কার্ট থেকে সরানো হয়েছে",
    orderSummary: "অর্ডার সারাংশ",
    haveCoupon: "কুপন আছে?",
    enterCode: "কোড লিখুন",
    apply: "প্রয়োগ করুন",
    invalidCoupon: "কুপন কোড সঠিক নয়",
    couponValidationFailed: "কুপন যাচাই করা যায়নি",
    removeCoupon: "কুপন সরান",
    discount: "ছাড়",
    coupon: "কুপন",
    tax: "কর (ভ্যাট)",
    shippingAtCheckout: "চেকআউটে শিপিং চার্জ হিসাব করা হবে",
    vatBadge: "ভ্যাট {percent}%",
    decreaseQuantity: "পরিমাণ কমান",
    increaseQuantity: "পরিমাণ বাড়ান",
    removeItem: "পণ্য সরান",
    removeItemTitle: "পণ্য সরান",
    removeItemConfirm:
      'আপনি কি নিশ্চিত যে "{name}" কার্ট থেকে সরাতে চান? এটি আর ফেরানো যাবে না।',
    saveAmount: "সাশ্রয় {amount}",
  },
  checkout: {
    loading: "চেকআউট লোড হচ্ছে...",
    title: "চেকআউট",
    subtitle: "মাত্র কয়েকটি ধাপে আপনার অর্ডার সম্পূর্ণ করুন",
    backToCart: "কার্টে ফিরে যান",
    processingOrder: "আপনার অর্ডার প্রক্রিয়া করা হচ্ছে",
    processingWait: "অনুগ্রহ করে অপেক্ষা করুন, আমরা আপনার অর্ডার নিশ্চিত করছি...",
    fixErrors: "নিচের ভুলগুলো ঠিক করুন",
    noShippingOptions: "এই ঠিকানার জন্য কোনো শিপিং অপশন নেই",
    shippingFetchFailed: "শিপিং অপশন আনা যায়নি। আবার চেষ্টা করুন।",
    shippingMethodUnavailable: "নির্বাচিত শিপিং পদ্ধতি পাওয়া যাচ্ছে না",
    fillCustomerInfo: "অনুগ্রহ করে গ্রাহকের তথ্য পূরণ করুন",
    completeCustomerForm: "অনুগ্রহ করে গ্রাহক তথ্যের ফর্মটি সম্পূর্ণ করুন",
    firstNameRequired: "নামের প্রথম অংশ আবশ্যক",
    phoneRequired: "ফোন নম্বর আবশ্যক",
    addressRequired: "ঠিকানা আবশ্যক",
    cityRequired: "শহর আবশ্যক",
    fillField: "অনুগ্রহ করে পূরণ করুন: {field}",
    fillFields:
      "অনুগ্রহ করে {count}টি আবশ্যক ঘর পূরণ করুন (হাইলাইট করা ঘর দেখতে নিচে স্ক্রল করুন)",
    fieldFirstName: "নামের প্রথম অংশ",
    fieldLastName: "নামের শেষ অংশ",
    fieldPhone: "ফোন",
    fieldAddress: "ঠিকানা",
    fieldAddressLine2: "ঠিকানা লাইন ২",
    fieldCity: "শহর",
    fieldPostcode: "পোস্টকোড",
    fieldCountry: "দেশ",
    selectDeliveryMethod: "অর্ডার নিশ্চিত করার আগে একটি ডেলিভারি পদ্ধতি নির্বাচন করুন।",
    selectPaymentMethod: "অর্ডার নিশ্চিত করার আগে একটি পেমেন্ট পদ্ধতি নির্বাচন করুন।",
    paymentMethodUnavailable:
      "নির্বাচিত পেমেন্ট পদ্ধতি পাওয়া যাচ্ছে না। অন্য একটি পদ্ধতি নির্বাচন করুন।",
    transactionIdRequired: "পেমেন্ট যাচাইয়ের জন্য ট্রানজেকশন আইডি আবশ্যক।",
    screenshotRequired: "যাচাইয়ের জন্য পেমেন্টের স্ক্রিনশট আবশ্যক।",
    bankSlipRequired: "ব্যাংক ট্রান্সফারের স্লিপ আবশ্যক।",
    orderMissingId:
      "অর্ডার তৈরি হয়েছে কিন্তু আইডি পাওয়া যায়নি। আপনার অর্ডার হিস্ট্রি দেখুন।",
    bkashInitFailed: "বিকাশ পেমেন্ট শুরু করা যায়নি",
    gatewayConnectFailed: "পেমেন্ট গেটওয়ের সাথে সংযোগ করা যায়নি",
    bkashPaymentFailed:
      "বিকাশ পেমেন্ট ব্যর্থ: {error}। আপনার অর্ডার গ্রহণ করা হয়েছে, কিন্তু এখনো পরিশোধ করা হয়নি। পেমেন্টের জন্য অনুগ্রহ করে দোকানে যোগাযোগ করুন।",
    shurjopayPaymentFailed:
      "আপনার অর্ডার গ্রহণ করা হয়েছে, কিন্তু shurjoPay পেমেন্ট শুরু করা যায়নি: {error}। অর্ডারটি এখনো পরিশোধ করা হয়নি। অনুগ্রহ করে দোকানে যোগাযোগ করুন।",
    orderCreationFailed: "অর্ডার তৈরি ব্যর্থ হয়েছে",
    orderProcessingError: "অর্ডার প্রক্রিয়ার সময় একটি ত্রুটি ঘটেছে। আবার চেষ্টা করুন।",
    selectDeliveryLocation: "ডেলিভারি লোকেশন নির্বাচন করুন",
    selectLocationHint:
      "শিপিং অপশন ও ডেলিভারি চার্জ দেখতে উপরে দেশ, বিভাগ ও শহর নির্বাচন করুন।",
    // CustomerInformationForm
    customerInfo: "গ্রাহকের তথ্য",
    clear: "মুছুন",
    useSavedAddress: "সংরক্ষিত ঠিকানা ব্যবহার করুন",
    addNewAddress: "নতুন ঠিকানা যোগ করুন",
    defaultBadge: "ডিফল্ট",
    noteLabel: "নোট:",
    fieldName: "নাম",
    enterFullName: "আপনার পুরো নাম লিখুন",
    addressLabel: "ঠিকানার লেবেল",
    labelHome: "বাসা",
    labelWork: "কর্মস্থল",
    labelOffice: "অফিস",
    labelOther: "অন্যান্য",
    selectLabel: "লেবেল নির্বাচন করুন",
    addressLine1Label: "ঠিকানা লাইন ১",
    addressLine1Placeholder: "বাসা ১২৩, রোড ৪৫",
    addressLine2Placeholder: "বনানী",
    selectCountry: "দেশ নির্বাচন করুন",
    divisionState: "বিভাগ / রাজ্য",
    selectDivision: "বিভাগ নির্বাচন করুন",
    cityDistrict: "শহর / জেলা",
    selectCity: "শহর নির্বাচন করুন",
    optional: "ঐচ্ছিক",
    formatLabel: "ফরম্যাট:",
    deliveryInstructionsOptional: "ডেলিভারি নির্দেশনা (ঐচ্ছিক)",
    deliveryInstructionsPlaceholder: "ডেলিভারির আগে ফোন করুন...",
    // DeliveryMethodSelection
    selectDeliveryMethodTitle: "ডেলিভারি পদ্ধতি নির্বাচন করুন",
    calculatingDelivery: "ডেলিভারি চার্জ হিসাব হচ্ছে...",
    selectDeliveryToContinue: "চালিয়ে যেতে একটি ডেলিভারি পদ্ধতি নির্বাচন করুন",
    homeDelivery: "হোম ডেলিভারি",
    homeDeliveryDesc: "আপনার দোরগোড়ায় অর্ডার পৌঁছে দেব",
    homeDeliveryEta: "৩-৫ কর্মদিবস",
    storePickup: "স্টোর পিকআপ",
    storePickupDesc: "আমাদের দোকান থেকে অর্ডার সংগ্রহ করুন",
    storePickupEta: "২-৪ ঘণ্টায় প্রস্তুত",
    unitMinute: "মিনিট",
    unitMinutes: "মিনিট",
    unitDay: "দিন",
    unitDays: "দিন",
    unitHour: "ঘণ্টা",
    unitHours: "ঘণ্টা",
    unitDayShort: "দি",
    unitHourShort: "ঘ",
    // OrderOverview
    orderOverview: "অর্ডার সংক্ষেপ",
    discountSavings: "ছাড়ে সাশ্রয়",
    estDelivery: "সম্ভাব্য ডেলিভারি: {time}",
    payableRounded: "প্রদেয় (রাউন্ড করা)",
    processing: "প্রক্রিয়া হচ্ছে...",
    confirmOrder: "অর্ডার নিশ্চিত করুন",
    // CheckoutCouponInput
    couponCode: "কুপন কোড",
    enterCouponCode: "কুপন কোড লিখুন",
    // PaymentMethodSelection
    selectPaymentMethodTitle: "পেমেন্ট পদ্ধতি নির্বাচন করুন",
    sendPaymentTo: "পেমেন্ট পাঠান:",
    accountType: "({name} - পার্সোনাল/মার্চেন্ট)",
    transactionId: "ট্রানজেকশন আইডি",
    enterTrxId: "TrxID লিখুন",
    screenshot: "স্ক্রিনশট",
    uploadScreenshot: "স্ক্রিনশট আপলোড করুন",
    uploadImageFile: "একটি ছবির ফাইল আপলোড করুন",
    fileTooLarge: "ফাইলের আকার ১০MB-এর কম হতে হবে",
    imageProcessFailed: "ছবি প্রক্রিয়া করা যায়নি",
    uploadImageOrPdf: "ছবি বা PDF ফাইল আপলোড করুন",
    bankSlip: "ব্যাংক স্লিপ",
    uploadBankSlip: "ব্যাংক স্লিপ আপলোড করুন",
    bankLabel: "ব্যাংক:",
    nameLabel: "নাম:",
    accountLabel: "হিসাব নং:",
    branchLabel: "শাখা:",
    notesLabel: "নোট",
    paymentReference: "পেমেন্ট রেফারেন্স",
    cashOnDelivery: "ক্যাশ অন ডেলিভারি",
    onlinePayment: "অনলাইন পেমেন্ট",
    offlinePayment: "অন্যান্য পেমেন্ট পদ্ধতি",
  },
  orderSuccess: {
    title: "অর্ডার নিশ্চিত হয়েছে!",
    subtitle: "আপনার অর্ডারের জন্য ধন্যবাদ। আমরা এটি পেয়েছি এবং শীঘ্রই প্রক্রিয়া করব।",
    orderDetails: "অর্ডারের বিবরণ",
    orderIdLabel: "অর্ডার আইডি:",
    orderStatus: "অর্ডারের অবস্থা",
    paymentStatus: "পেমেন্টের অবস্থা",
    paymentMethod: "পেমেন্ট পদ্ধতি",
    totalItems: "মোট পণ্য",
    estimatedDelivery: "সম্ভাব্য ডেলিভারি",
    confirmationEmailSent: "নিশ্চিতকরণ ইমেইল পাঠানো হয়েছে",
    orderPlacedOn: "অর্ডার করা হয়েছে {date}",
    deliveryInfo: "ডেলিভারির তথ্য",
    phoneLabel: "ফোন:",
    emailLabel: "ইমেইল:",
    orderItems: "অর্ডারের পণ্য ({count})",
    variantLabel: "ভ্যারিয়েন্ট: {variant}",
    qty: "পরিমাণ: {quantity}",
    perUnitDiscount: "-{amount}/প্রতি ইউনিট",
    vatIncluded: "ভ্যাট অন্তর্ভুক্ত: {amount}",
    whatNext: "এরপর কী হবে?",
    confirmEmailNote: "আপনি অর্ডার নিশ্চিতকরণ ইমেইল পাবেন",
    trackingNote: "অর্ডার শিপ হলে আমরা আপনাকে ট্র্যাকিং তথ্য পাঠাব",
    expectedDelivery: "সম্ভাব্য ডেলিভারি: {date}",
    processedSoon: "আপনার অর্ডার শীঘ্রই প্রক্রিয়া ও শিপ করা হবে",
    codNote: "ডেলিভারির সময় পেমেন্ট নেওয়া হবে",
    downloadPdf: "পিডিএফ ডাউনলোড",
    backToHome: "হোমে ফিরে যান",
    pdfFailed: "পিডিএফ তৈরি করা যায়নি। আবার চেষ্টা করুন।",
  },
  payment: {
    title: "পেমেন্ট সম্পূর্ণ করুন",
    subtitle: "অর্ডার সম্পূর্ণ করতে আর মাত্র এক ধাপ বাকি",
    backToCheckout: "চেকআউটে ফিরে যান",
    totalAmount: "মোট পরিমাণ",
    demoNotice: "এটি একটি ডেমো পেমেন্ট পেজ। কোনো প্রকৃত পেমেন্ট প্রক্রিয়া হবে না।",
    cardNumber: "কার্ড নম্বর",
    expiryDate: "মেয়াদ শেষের তারিখ",
    cvv: "সিভিভি (CVV)",
    processing: "পেমেন্ট প্রক্রিয়া হচ্ছে...",
    payAmount: "{amount} পরিশোধ করুন",
    sslNotice: "🔒 পেমেন্ট ২৫৬-বিট SSL এনক্রিপশনে সুরক্ষিত",
    failed: "পেমেন্ট ব্যর্থ হয়েছে। আবার চেষ্টা করুন।",
  },
  // The page a shopper returns to from an online payment gateway (shurjoPay).
  gatewayReturn: {
    processingTitle: "আপনার পেমেন্ট নিশ্চিত করা হচ্ছে",
    processing: "shurjoPay-এর সাথে যাচাই করা হচ্ছে। কয়েক সেকেন্ড সময় লাগবে।",
    paidTitle: "পেমেন্ট সফল হয়েছে",
    paid: "আপনার পেমেন্ট পাওয়া গেছে এবং অর্ডার নিশ্চিত হয়েছে।",
    redirecting: "আপনার অর্ডারে নিয়ে যাওয়া হচ্ছে...",
    pendingTitle: "পেমেন্ট এখনো সম্পন্ন হয়নি",
    pending: "shurjoPay এখনো এই পেমেন্ট নিশ্চিত করেনি। আপনি পেমেন্ট সম্পন্ন করে থাকলে এক মিনিট পরে আবার যাচাই করুন।",
    mismatchTitle: "পেমেন্টটি যাচাই করা প্রয়োজন",
    mismatch: "shurjoPay যে পেমেন্টের তথ্য দিয়েছে তা আপনার অর্ডারের মোট মূল্যের সাথে মেলেনি। অর্ডারটি এখনো পরিশোধিত হিসেবে চিহ্নিত হয়নি; দোকানের কাছে বিস্তারিত আছে এবং তারা আপনার সাথে যোগাযোগ করবে।",
    cancelledTitle: "পেমেন্ট বাতিল হয়েছে",
    cancelled: "আপনি পেমেন্ট বাতিল করেছেন। আপনার অর্ডার সংরক্ষিত আছে, তবে পরিশোধ করা হয়নি।",
    failedTitle: "পেমেন্ট ব্যর্থ হয়েছে",
    failed: "shurjoPay পেমেন্টটি গ্রহণ করেনি। আপনার অর্ডার সংরক্ষিত আছে, তবে পরিশোধ করা হয়নি।",
    errorTitle: "পেমেন্ট নিশ্চিত করা যায়নি",
    error: "এই মুহূর্তে পেমেন্টটি নিশ্চিত করা যাচ্ছে না। আপনার অ্যাকাউন্ট থেকে টাকা কেটে থাকলে এক মিনিট পরে আবার যাচাই করুন, অথবা দোকানে যোগাযোগ করুন।",
    sessionMissing: "এই পেমেন্টটি অন্য ব্রাউজারে শুরু হয়েছিল, অথবা সেশনের মেয়াদ শেষ হয়ে গেছে। অবস্থা জানতে আপনার অর্ডারগুলো দেখুন।",
    checkAgain: "আবার যাচাই করুন",
    viewOrders: "আমার অর্ডারগুলো দেখুন",
    backToShop: "দোকানে ফিরে যান",
  },
  header: {
    home: "হোম",
    shop: "দোকান",
    categories: "বিভাগ",
    brands: "ব্র্যান্ড",
    account: "আমার অ্যাকাউন্ট",
    login: "লগইন",
    logout: "লগআউট",
    wishlist: "পছন্দের তালিকা",
    cart: "কার্ট",
    blog: "ব্লগ",
  },
  auth: {
    // Shared fields
    emailLabel: "ইমেইল ঠিকানা",
    emailPlaceholder: "your@email.com",
    passwordLabel: "পাসওয়ার্ড",
    confirmPasswordLabel: "পাসওয়ার্ড নিশ্চিত করুন",
    passwordHint: "কমপক্ষে ৮ অক্ষরের হতে হবে",
    signIn: "সাইন ইন",
    signInLink: "সাইন ইন করুন",
    signingIn: "সাইন ইন হচ্ছে...",
    genericError: "একটি সমস্যা হয়েছে। আবার চেষ্টা করুন।",
    genericErrorLater: "একটি সমস্যা হয়েছে। কিছুক্ষণ পর আবার চেষ্টা করুন।",
    invalidEmail: "ইমেইল ঠিকানা সঠিক নয়",
    invalidPassword: "পাসওয়ার্ড সঠিক নয়",
    // Login
    welcomeBack: "আবারও স্বাগতম",
    signInSubtitle: "চালিয়ে যেতে আপনার অ্যাকাউন্টে সাইন ইন করুন",
    rememberMe: "আমাকে মনে রাখুন",
    forgotPasswordLink: "পাসওয়ার্ড ভুলে গেছেন?",
    sessionExpired: "আপনার সেশনের মেয়াদ শেষ হয়েছে। আবার লগইন করুন।",
    loginSuccess: "লগইন সফল হয়েছে! রিডাইরেক্ট হচ্ছে...",
    loginFailed: "লগইন ব্যর্থ হয়েছে। আবার চেষ্টা করুন।",
    saveLoginFailed: "লগইন তথ্য সংরক্ষণ করা যায়নি। আবার চেষ্টা করুন।",
    invalidPasswordFormat: "পাসওয়ার্ডের ফরম্যাট সঠিক নয়",
    noAccount: "অ্যাকাউন্ট নেই?",
    signUpNow: "এখনই সাইন আপ করুন",
    // Signup
    createAccount: "অ্যাকাউন্ট তৈরি করুন",
    signupSubtitle: "আমাদের সাথে যোগ দিন এবং কেনাকাটা শুরু করুন",
    nameLabel: "পুরো নাম",
    namePlaceholder: "আপনার পুরো নাম",
    phoneLabel: "ফোন নম্বর",
    phonePlaceholder: "01712345678",
    agreeToTermsPrefix: "আমি",
    agreeToTermsSuffix: "মেনে নিচ্ছি",
    termsAndConditions: "শর্তাবলী",
    and: "এবং",
    privacyPolicy: "গোপনীয়তা নীতি",
    errNameMin: "নাম কমপক্ষে ২ অক্ষরের হতে হবে",
    errEmailRequired: "ইমেইল আবশ্যক",
    errEmailInvalid: "ইমেইল সঠিক নয়",
    errPhoneRequired: "ফোন নম্বর আবশ্যক",
    errPhoneInvalid: "সঠিক ফোন নম্বর লিখুন",
    errPasswordRequired: "পাসওয়ার্ড আবশ্যক",
    errPasswordMin: "পাসওয়ার্ড কমপক্ষে ৮ অক্ষরের হতে হবে",
    errConfirmPasswordRequired: "পাসওয়ার্ড নিশ্চিত করুন",
    errPasswordsMismatch: "পাসওয়ার্ড দুটি মিলছে না",
    errTermsRequired: "শর্তাবলীতে সম্মত হতে হবে",
    fixValidationErrors: "নিচের ভুলগুলো ঠিক করুন",
    otpSendFailed: "ভেরিফিকেশন কোড পাঠানো যায়নি।",
    otpSendFailedRetry: "ভেরিফিকেশন কোড পাঠানো যায়নি। আবার চেষ্টা করুন।",
    signupFailed: "সাইন আপ ব্যর্থ হয়েছে। আবার চেষ্টা করুন।",
    phoneVerified: "ফোন নম্বর যাচাই হয়েছে!",
    creatingAccount: "আপনার অ্যাকাউন্ট তৈরি হচ্ছে...",
    accountCreated: "অ্যাকাউন্ট সফলভাবে তৈরি হয়েছে! রিডাইরেক্ট হচ্ছে...",
    sendingCode: "ভেরিফিকেশন কোড পাঠানো হচ্ছে...",
    alreadyHaveAccount: "ইতিমধ্যে অ্যাকাউন্ট আছে?",
    // Mobile OTP auth (mobile-only tenants)
    mobileSignInSubtitle:
      "আপনার মোবাইল নম্বর দিয়ে সাইন ইন করুন। আমরা SMS-এ একটি কোড পাঠাব।",
    mobileNumberLabel: "মোবাইল নম্বর",
    sendVerificationCode: "ভেরিফিকেশন কোড পাঠান",
    signingYouIn: "সাইন ইন করানো হচ্ছে…",
    getStarted: "শুরু করুন",
    mobileSignupSubtitle:
      "শুধু নাম আর মোবাইল নম্বর দিয়েই দ্রুত কেনাকাটা করুন। ইমেইল বা পাসওয়ার্ড লাগবে না। একটি ছোট SMS কোড দিয়ে আপনাকে যাচাই করা হবে।",
    creatingYourAccount: "আপনার অ্যাকাউন্ট তৈরি হচ্ছে…",
    createOne: "একটি তৈরি করুন",
    verifyYourPhone: "আপনার ফোন যাচাই করুন",
    otpSentTo: "আমরা ৬ সংখ্যার একটি কোড পাঠিয়েছি এই নম্বরে",
    verifyCode: "কোড যাচাই করুন",
    verifying: "যাচাই হচ্ছে...",
    verifiedCreating: "যাচাই সম্পন্ন! অ্যাকাউন্ট তৈরি হচ্ছে...",
    resendIn: "{time} পরে আবার কোড পাঠানো যাবে",
    resendCode: "আবার কোড পাঠান",
    changePhoneNumber: "ফোন নম্বর পরিবর্তন করুন",
    errOtpEnter6: "৬ সংখ্যার কোডটি লিখুন",
    errOtpResendFailed: "কোড আবার পাঠানো যায়নি।",
    errOtpInvalid: "কোডটি সঠিক নয়। আবার চেষ্টা করুন।",
    errVerificationFailed: "যাচাই ব্যর্থ হয়েছে। আবার চেষ্টা করুন।",
    // Forgot password
    forgotTitle: "পাসওয়ার্ড ভুলে গেছেন",
    forgotSubtitle:
      "আপনার ইমেইল ঠিকানা লিখুন, আমরা পাসওয়ার্ড রিসেট করার লিংক পাঠাব।",
    checkYourEmail: "আপনার ইমেইল দেখুন",
    resetLinkSentTo: "পাসওয়ার্ড রিসেট লিংক পাঠানো হয়েছে এই ঠিকানায়:",
    checkSpam: "ইমেইল পাননি? স্প্যাম ফোল্ডার দেখুন বা আবার চেষ্টা করুন।",
    tryAnotherEmail: "অন্য ইমেইল দিয়ে চেষ্টা করুন",
    sending: "পাঠানো হচ্ছে...",
    sendResetLink: "রিসেট লিংক পাঠান",
    rememberPassword: "পাসওয়ার্ড মনে পড়েছে?",
    // Reset password
    resetTitle: "পাসওয়ার্ড রিসেট করুন",
    resetSubtitle: "নিচে আপনার নতুন পাসওয়ার্ড লিখুন।",
    newPasswordLabel: "নতুন পাসওয়ার্ড",
    newPasswordPlaceholder: "নতুন পাসওয়ার্ড লিখুন",
    confirmNewPasswordPlaceholder: "নতুন পাসওয়ার্ড আবার লিখুন",
    invalidResetLink: "রিসেট লিংক সঠিক নয়",
    invalidResetLinkDesc:
      "এই পাসওয়ার্ড রিসেট লিংকটি সঠিক নয় বা মেয়াদ শেষ হয়ে গেছে।",
    requestNewLinkHint: "নতুন পাসওয়ার্ড রিসেট লিংকের জন্য অনুরোধ করুন।",
    requestNewLink: "নতুন লিংকের অনুরোধ করুন",
    resetSuccessTitle: "পাসওয়ার্ড সফলভাবে রিসেট হয়েছে",
    resetSuccessDesc: "আপনার পাসওয়ার্ড রিসেট হয়েছে। লগইন পেজে নিয়ে যাওয়া হচ্ছে...",
    goToLogin: "লগইন পেজে যান",
    resettingPassword: "পাসওয়ার্ড রিসেট হচ্ছে...",
    // Email verification
    verifyingEmail: "আপনার ইমেইল যাচাই হচ্ছে...",
    emailVerifiedTitle: "ইমেইল যাচাই সম্পন্ন",
    emailVerifiedDesc: "আপনার ইমেইল ঠিকানা সফলভাবে যাচাই হয়েছে।",
    continueToCheckout: "চেকআউটে যান",
    continueToLogin: "লগইনে যান",
    verifyFailedTitle: "যাচাই ব্যর্থ হয়েছে",
    verifyFailedDesc: "এই যাচাই লিংকটি সঠিক নয় বা মেয়াদ শেষ হয়ে গেছে।",
    verifyFailedHint:
      "আপনার অ্যাকাউন্টে লগইন করে চেকআউট পেজ থেকে নতুন যাচাই ইমেইল পাঠান।",
    // Checkout verification gate
    verificationRequiredTitle: "আপনার অ্যাকাউন্ট যাচাই করুন",
    verificationRequiredDesc:
      "অর্ডার করার আগে আপনার ইমেইল ঠিকানা যাচাই করুন। আমরা যাচাই লিংক পাঠাব এই ঠিকানায়:",
    resendVerification: "যাচাই ইমেইল আবার পাঠান",
    verificationSent: "যাচাই ইমেইল পাঠানো হয়েছে!",
    checkInbox: "আপনার ইনবক্স দেখুন এবং ইমেইল যাচাই করতে লিংকে ক্লিক করুন।",
    iVerifiedRefresh: "যাচাই করেছি, রিফ্রেশ করুন",
    resendCooldown:
      "সম্প্রতি একটি যাচাই ইমেইল পাঠানো হয়েছে। আবার চেষ্টা করার আগে এক মিনিট অপেক্ষা করুন।",
  },
  account: {
    // Dashboard
    hello: "হ্যালো,",
    notLoggedIn: "লগইন করা নেই",
    notLoggedInMessage: "আপনার অ্যাকাউন্ট ড্যাশবোর্ডে প্রবেশ করতে লগইন করুন।",
    backToDashboard: "ড্যাশবোর্ডে ফিরে যান",
    ordersCard: "অর্ডারসমূহ",
    ordersCardDesc: "আপনার অর্ডার দেখুন ও ট্র্যাক করুন",
    profileCard: "প্রোফাইল",
    profileCardDesc: "আপনার প্রোফাইল তথ্য দেখুন",
    changePassword: "পাসওয়ার্ড পরিবর্তন",
    changePasswordDesc: "আপনার পাসওয়ার্ড আপডেট করুন",
    // Complete-account (credentials) card
    completeAccountTitle: "আপনার অ্যাকাউন্ট সম্পূর্ণ করুন",
    completeAccountMessage:
      "আপনি শুধু মোবাইল নম্বর দিয়ে সাইন আপ করেছেন। অন্য ডিভাইসে লগইন করতে একটি ইমেইল ও পাসওয়ার্ড যোগ করুন।",
    addEmail: "ইমেইল যোগ করুন",
    emailAdded: "ইমেইল যোগ হয়েছে।",
    addEmailFailed: "ইমেইল যোগ করা যায়নি",
    setPasswordLabel: "একটি পাসওয়ার্ড সেট করুন",
    setPassword: "পাসওয়ার্ড সেট করুন",
    passwordSet: "পাসওয়ার্ড সেট হয়েছে।",
    setPasswordFailed: "পাসওয়ার্ড সেট করা যায়নি",
    saving: "সংরক্ষণ হচ্ছে…",
    // Profile
    profileInformation: "প্রোফাইল তথ্য",
    editProfile: "প্রোফাইল সম্পাদনা",
    name: "নাম",
    email: "ইমেইল",
    mobile: "মোবাইল",
    mobileNumber: "মোবাইল নম্বর",
    notSet: "সেট করা নেই",
    userId: "ইউজার আইডি",
    updateProfile: "প্রোফাইল আপডেট করুন",
    updating: "আপডেট হচ্ছে...",
    profileUpdated: "প্রোফাইল সফলভাবে আপডেট হয়েছে! রিডাইরেক্ট হচ্ছে...",
    profileUpdateFailed: "প্রোফাইল আপডেট ব্যর্থ হয়েছে। আবার চেষ্টা করুন।",
    invalidInput: "অবৈধ বা ক্ষতিকর ইনপুট শনাক্ত হয়েছে: ",
    loadingCountries: "দেশের তালিকা লোড হচ্ছে...",
    loadingDivisions: "বিভাগ লোড হচ্ছে...",
    loadingCities: "শহর লোড হচ্ছে...",
    selectCountryFirst: "আগে দেশ নির্বাচন করুন",
    noDivisions: "কোনো বিভাগ নেই",
    noCities: "কোনো শহর নেই",
    selectCityOptional: "শহর/জেলা নির্বাচন করুন (ঐচ্ছিক)",
    selectDivisionHint: "বিভাগ বা রাজ্য নির্বাচন করুন",
    selectedValue: "নির্বাচিত: {name}",
    cityOptionalHint: "ঐচ্ছিক: নির্দিষ্ট শহর বা জেলা নির্বাচন করুন",
    // Security / password
    currentPassword: "বর্তমান পাসওয়ার্ড",
    currentPasswordPlaceholder: "আপনার বর্তমান পাসওয়ার্ড লিখুন",
    confirmNewPasswordLabel: "নতুন পাসওয়ার্ড নিশ্চিত করুন",
    currentPasswordRequired: "বর্তমান পাসওয়ার্ড প্রয়োজন",
    newPasswordRequired: "নতুন পাসওয়ার্ড প্রয়োজন",
    newPasswordMin: "নতুন পাসওয়ার্ড কমপক্ষে ৮ অক্ষরের হতে হবে",
    newPasswordSame: "নতুন পাসওয়ার্ড বর্তমান পাসওয়ার্ড থেকে আলাদা হতে হবে",
    invalidCurrentPassword: "বর্তমান পাসওয়ার্ডের ফরম্যাট সঠিক নয়",
    invalidNewPassword: "নতুন পাসওয়ার্ড সঠিক নয়",
    securityTipTitle: "নিরাপত্তা পরামর্শ:",
    securityTipBody:
      "কমপক্ষে ৮ অক্ষরের শক্তিশালী পাসওয়ার্ড ব্যবহার করুন, যাতে বড় হাতের ও ছোট হাতের অক্ষর, সংখ্যা ও বিশেষ চিহ্ন থাকে।",
    passwordUpdated: "পাসওয়ার্ড সফলভাবে আপডেট হয়েছে! প্রোফাইলে ফিরে যাচ্ছে...",
    passwordUpdateFailed: "পাসওয়ার্ড আপডেট ব্যর্থ হয়েছে। আবার চেষ্টা করুন।",
    // Orders
    myOrders: "আমার অর্ডার",
    noOrdersYet: "এখনো কোনো অর্ডার নেই",
    noOrdersMessage: "আপনি এখনো কোনো অর্ডার করেননি।",
    showingOrders: "{total}টি অর্ডারের মধ্যে {from} - {to} দেখানো হচ্ছে",
    orderNumberTitle: "অর্ডার #{number}",
    orderNumber: "অর্ডার নম্বর",
    date: "তারিখ",
    items: "পণ্য",
    payment: "পেমেন্ট",
    loadingOrders: "অর্ডার লোড হচ্ছে...",
    fetchOrdersFailed: "অর্ডার আনা যায়নি",
    loadOrdersFailed: "অর্ডার লোড করা যায়নি। আবার চেষ্টা করুন।",
    businessIdRequired: "অর্ডার আনতে বিজনেস আইডি প্রয়োজন।",
    pageOf: "পৃষ্ঠা {current} / {last}",
    previous: "পূর্ববর্তী",
    next: "পরবর্তী",
    backToOrders: "অর্ডারে ফিরে যান",
    orderNotFound: "অর্ডার পাওয়া যায়নি",
    fetchOrderDetailsFailed: "অর্ডারের বিস্তারিত আনা যায়নি",
    loadOrderDetailsFailed: "অর্ডারের বিস্তারিত লোড করা যায়নি। আবার চেষ্টা করুন।",
    // Order / payment statuses (backend values)
    statusPending: "অপেক্ষমাণ",
    statusProcessing: "প্রক্রিয়াধীন",
    statusConfirmed: "নিশ্চিত",
    statusCompleted: "সম্পন্ন",
    statusCancelled: "বাতিল",
    statusShipped: "শিপ হয়েছে",
    statusDelivered: "ডেলিভারি হয়েছে",
    statusPaid: "পরিশোধিত",
    statusFailed: "ব্যর্থ",
    statusRefunded: "ফেরত দেওয়া হয়েছে",
    statusOnHold: "স্থগিত",
    // Addresses
    myAddresses: "আমার ঠিকানা",
    addressCountOne: "১টি ঠিকানা",
    addressCount: "{count}টি ঠিকানা",
    noAddresses: "কোনো ঠিকানা সংরক্ষিত নেই",
    noAddressesMessage: "ভবিষ্যৎ অর্ডারের জন্য একটি নতুন ঠিকানা যোগ করুন",
    editAddress: "ঠিকানা সম্পাদনা",
    updateAddress: "ঠিকানা আপডেট করুন",
    addAddress: "ঠিকানা যোগ করুন",
    adding: "যোগ হচ্ছে...",
    deleting: "মুছে ফেলা হচ্ছে...",
    edit: "সম্পাদনা",
    delete: "মুছুন",
    confirm: "নিশ্চিত করুন",
    deleteAddressTitle: "ঠিকানা মুছুন",
    deleteAddressConfirm:
      "আপনি কি নিশ্চিত এই ঠিকানাটি মুছতে চান? এই কাজটি পূর্বাবস্থায় ফেরানো যাবে না।",
    fetchAddressesFailed: "ঠিকানা আনা যায়নি",
    loadAddressesFailed: "ঠিকানা লোড করা যায়নি। আবার চেষ্টা করুন।",
    deleteAddressFailed: "ঠিকানা মোছা যায়নি। আবার চেষ্টা করুন।",
    updateAddressFailed: "ঠিকানা আপডেট করা যায়নি",
    addAddressFailed: "ঠিকানা যোগ করা যায়নি",
    addressLabelPlaceholder: "যেমন: বাসা, অফিস ইত্যাদি",
    streetAddressPlaceholder: "রাস্তার ঠিকানা",
    addressLine2Placeholder: "অ্যাপার্টমেন্ট, স্যুট ইত্যাদি (ঐচ্ছিক)",
    county: "কাউন্টি",
    countryUnitedKingdom: "যুক্তরাজ্য",
    countryUnitedStates: "যুক্তরাষ্ট্র",
    countryCanada: "কানাডা",
    countryAustralia: "অস্ট্রেলিয়া",
    countryIreland: "আয়ারল্যান্ড",
    countrySaudiArabia: "সৌদি আরব",
    countryBangladesh: "বাংলাদেশ",
    // Wishlist
    myWishlist: "আমার পছন্দের তালিকা",
    itemCountOne: "১টি পণ্য",
    itemCount: "{count}টি পণ্য",
    wishlistEmpty: "আপনার পছন্দের তালিকা খালি",
    wishlistEmptyMessage: "পরে দেখার জন্য আপনার পছন্দের পণ্য যোগ করা শুরু করুন",
    gridView: "গ্রিড ভিউ",
    tilesView: "তালিকা ভিউ",
    clearWishlist: "তালিকা খালি করুন",
    clearing: "খালি করা হচ্ছে...",
    clearWishlistConfirm:
      "আপনি কি নিশ্চিত পুরো পছন্দের তালিকা খালি করতে চান? এই কাজটি পূর্বাবস্থায় ফেরানো যাবে না।",
    clearWishlistFailed: "পছন্দের তালিকা খালি করা যায়নি। আবার চেষ্টা করুন।",
    removeFromWishlist: "পছন্দের তালিকা থেকে সরান",
    removing: "সরানো হচ্ছে...",
    removeWishlistFailed: "পছন্দের তালিকা থেকে পণ্যটি সরানো যায়নি। আবার চেষ্টা করুন।",
    addedOn: "যোগ হয়েছে {date}",
    viewProduct: "পণ্য দেখুন",
    loadingWishlist: "পছন্দের তালিকা লোড হচ্ছে...",
    fetchWishlistFailed: "পছন্দের তালিকা আনা যায়নি",
    loadWishlistFailed: "পছন্দের তালিকা লোড করা যায়নি। আবার চেষ্টা করুন।",
    // Common
    noAccessToken: "অ্যাক্সেস টোকেন পাওয়া যায়নি। আবার লগইন করুন।",
  },
  footer: {
    aboutUs: "আমাদের সম্পর্কে",
    contactUs: "যোগাযোগ করুন",
    privacyPolicy: "গোপনীয়তা নীতি",
    termsOfService: "সেবার শর্তাবলী",
    returnPolicy: "ফেরত নীতি",
    shippingInfo: "শিপিং তথ্য",
    followUs: "আমাদের অনুসরণ করুন",
    newsletter: "নিউজলেটার",
    subscribeNewsletter: "আমাদের নিউজলেটার সাবস্ক্রাইব করুন",
    enterEmail: "আপনার ইমেইল লিখুন",
    subscribe: "সাবস্ক্রাইব",
  },
  guestCheckout: guestCheckoutBn,
};
